import { create } from 'zustand';
import { createSelectors } from './createSelectors';

interface AppShellState {
  isInitialized: boolean;
  isThemeDrawerOpen: boolean;
  toggleThemeDrawer: (isOpen: boolean) => void;
  setIsInitialized: (isInitialized: boolean) => void;
}

const useAppShellStoreBase = create<AppShellState>((set) => ({
  isInitialized: false,
  setIsInitialized: (isInitialized: boolean) => set(() => ({ isInitialized })),
  isThemeDrawerOpen: false,
  toggleThemeDrawer: (isOpen) => set(() => ({ isThemeDrawerOpen: isOpen })),
}));

export const useAppShellStore = createSelectors(useAppShellStoreBase);
